/* eslint-disable no-unused-vars */

import Vue from 'vue'
import Vuex from 'vuex'
import CHALLENGE_CATEGORIES from "@/misc/challenge_categories.json";
import { LocalNotifications } from '@capacitor/local-notifications';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adList: JSON.parse(localStorage.getItem('adList')) || [],
    appPlatform: window.cordova ? (document.body.classList.contains('is-ios') ? 'ios' : 'android') : 'web',
    autoLaunchChat: JSON.parse(localStorage.getItem("autoLaunchChat")) || false,
    badTags: JSON.parse(localStorage.getItem('badTags')) || [],
    bedroomLanguage: JSON.parse(localStorage.getItem("bedroomLanguage")) || {},
    calendarOvulations: JSON.parse(localStorage.getItem("calendarOvulations")) || {showPastOvulationWindow:true, showFutureOvulationWindow:true, periodLength:5},
    challenge: JSON.parse(localStorage.getItem('challenge')) || { challenge: '', date: null},
    challengeArchive: JSON.parse(localStorage.getItem('challengeArchive')) || [],
    challengeHistory: JSON.parse(localStorage.getItem('challengeHistory')) || { streak: 0, lastDay: 0},
    challengeCategories: JSON.parse(localStorage.getItem('challengeCategories3')) || CHALLENGE_CATEGORIES,
    challengeSaveToCalendar: JSON.parse(localStorage.getItem('challengeSaveToCalendar')) || 'yes',
    challengeTomorrow: JSON.parse(localStorage.getItem('challengeTomorrow')) || null,
    conversationStarterQuestions: JSON.parse(localStorage.getItem("conversationStarterQuestions")) || null,
    conversationStarterCategories: JSON.parse(localStorage.getItem("conversationStarterCategories")) || null,
    firebaseToken: JSON.parse(localStorage.getItem('firebaseToken')) || {current: null, old: []},
    flatPageList: JSON.parse(localStorage.getItem("flatPageList")) || [],
    inAppPurchaseProducts: {},
    initializeCdvPurchaseStoreCalled: false,
    inviteCategoryData: JSON.parse(localStorage.getItem('inviteCategoryData')) || [],
    inviteData: JSON.parse(localStorage.getItem('inviteData')) || [],
    inviteUnlocked: JSON.parse(localStorage.getItem('inviteUnlocked')) || [],
    keepAliveKey: 0,
    languageSelected:JSON.parse(localStorage.getItem('languageSelected')) || 'en',
    latestFromRoute: { matched: [] },
    learnCategory: 0,
    learnArticleTimestamps: JSON.parse(localStorage.getItem('learnArticleTimestamps')) || {},
    menuShowing: false,
    okToPromptToEnableLocationPermission: JSON.parse(localStorage.getItem('okToPromptToEnableLocationPermission')) || true,
    onLine: navigator.onLine,
    packTags: JSON.parse(localStorage.getItem('packTags')) || {},
    referredBy: JSON.parse(localStorage.getItem('referredBy')) || null,
    reminderSettings: JSON.parse(localStorage.getItem("reminderSettings")) || {},
    remindersInitialized: JSON.parse(localStorage.getItem("remindersInitialized")) || false,
    remindersNextCustomId: JSON.parse(localStorage.getItem("remindersNextCustomId")) || 200,
    remindersUpdating: false,
    reviewData: JSON.parse(localStorage.getItem('reviewData')) || {counter: 0, status: ''},
    securityWall: JSON.parse(localStorage.getItem('securityWall')) || {enabled: false, passcode: '', useBiometrics: false},
    showSimpleGameTutorial: JSON.parse(localStorage.getItem('showSimpleGameTutorial')) || 'yes',
    showBoardGameTutorial: JSON.parse(localStorage.getItem('showBoardGameTutorial')) || 'yes',
    showHalloweenGameTutorial: JSON.parse(localStorage.getItem('showHalloweenGameTutorial')) || 'yes',
    showPlayExtra: false,
    showPositions: false,
    storiesSubstituteNames: JSON.parse(localStorage.getItem('storiesSubstituteNames')) || 'no',
    syncReminder: JSON.parse(localStorage.getItem('syncReminder')) || 0,
    timestampBeforeTemporaryPause: null,
    upgradePromptPoints: localStorage.getItem('upgradePromptPoints') || 0,
    userData: JSON.parse(localStorage.getItem("userData")) || null,
    whatsNewData: JSON.parse(localStorage.getItem("whatsNewData")) || {
      showIndicator: false,
      latestEntry: null,
      totalEntries: 0,
      latestReadEntryId: null,
    },
    latestBadgeId: JSON.parse(localStorage.getItem("latestBadgeId")) || null,
  },
  mutations: {
    adList(state, value) {
      state.adList = value;
      localStorage.setItem('adList', JSON.stringify(value));
    },
    autoLaunchChat(state, value) {
      state.autoLaunchChat = value;
      localStorage.setItem(
        "autoLaunchChat",
        JSON.stringify(value)
      );
    },
    badTags(state, value) {
      state.badTags = value;
      localStorage.setItem('badTags', JSON.stringify(value));
    },
    bedroomLanguage(state, value) {
      state.bedroomLanguage = value;
      localStorage.setItem(
        "bedroomLanguage",
        JSON.stringify(value)
      );
    },
    calendarOvulations(state, value){
      state.calendarOvulations = value;
      localStorage.setItem(
        "calendarOvulations",
        JSON.stringify(value)
      );
    },
    challenge(state, value) {
      state.challenge = value;
      localStorage.setItem(
        "challenge",
        JSON.stringify(value)
      );
    },
    challengeArchive(state, value) {
      state.challengeArchive = value;
      localStorage.setItem(
        "challengeArchive",
        JSON.stringify(value)
      );
    },
    challengeHistory(state, value) {
      state.challengeHistory = value;
      localStorage.setItem(
        "challengeHistory",
        JSON.stringify(value)
      );
    },
    challengeCategories(state, value) {
      state.challengeCategories = value;
      localStorage.setItem(
        "challengeCategories3",
        JSON.stringify(value)
      );
    },
    challengeSaveToCalendar(state, value) {
      state.challengeSaveToCalendar = value;
      localStorage.setItem(
        "challengeSaveToCalendar",
        JSON.stringify(value)
      );
    },
    challengeTomorrow(state, value) {
      state.challengeTomorrow = value;
      localStorage.setItem(
        "challengeTomorrow",
        JSON.stringify(value)
      );
    },
    conversationStarterQuestions(state, value) {
      state.conversationStarterQuestions = value;
      localStorage.setItem(
        "conversationStarterQuestions",
        JSON.stringify(value)
      );
    },
    conversationStarterCategories(state, value) {
      state.conversationStarterCategories = value;
      localStorage.setItem(
        "conversationStarterCategories",
        JSON.stringify(value)
      );
    },
    firebaseToken(state, value) {
      state.firebaseToken = value;
      localStorage.setItem("firebaseToken", JSON.stringify(value));
    },
    flatPageList(state, value) {
      state.flatPageList = value;
      localStorage.setItem("flatPageList", JSON.stringify(value));
    },
    inAppPurchaseProducts(state, payload) {
      Vue.set(state.inAppPurchaseProducts, payload.key, payload.value);
    },
    initializeCdvPurchaseStoreCalled(state) {
      state.initializeCdvPurchaseStoreCalled = true;
    },
    inviteCategoryData(state, value) {
      state.inviteCategoryData = value;
      localStorage.setItem('inviteCategoryData', JSON.stringify(value));
    },
    inviteData(state, value) {
      state.inviteData = value;
      localStorage.setItem('inviteData', JSON.stringify(value));
    },
    inviteUnlocked(state, value) {
      state.inviteUnlocked = value;
      localStorage.setItem('inviteUnlocked', JSON.stringify(value));
    },
    keepAliveKey(state) {
      state.keepAliveKey = Math.floor(Math.random() * 1000);
    },
    languageSelected(state, value){
      state.languageSelected = value;
      localStorage.setItem('languageSelected', JSON.stringify(value));
    },
    latestFromRoute(state, value) {
      state.latestFromRoute = value;
    },
    learnCategory(state, value) {
      state.learnCategory = value;
    },
    learnArticleTimestamps(state, value) {
      state.learnArticleTimestamps = value;
      localStorage.setItem('learnArticleTimestamps', JSON.stringify(value));
    },
    menuShowing(state, value) {
      state.menuShowing = value;
    },
    okToPromptToEnableLocationPermission(state, value) {
      state.okToPromptToEnableLocationPermission = value;
      localStorage.setItem(
        'okToPromptToEnableLocationPermission',
        JSON.stringify(value)
      );
    },
    onLine(state, value) {
      state.onLine = value;
    },
    packTags(state, value) {
      state.packTags = value;
      localStorage.setItem('packTags', JSON.stringify(value));
    },
    referredBy(state, value) {
      state.referredBy = value;
      localStorage.setItem('referredBy', JSON.stringify(value));
    },
    reminderSettings(state, value) {
      state.reminderSettings = value;
      localStorage.setItem("reminderSettings", JSON.stringify(value));
    },
    remindersInitialized(state, value) {
      state.remindersInitialized = value;
      localStorage.setItem("remindersInitialized", JSON.stringify(value));
    },
    remindersNextCustomId(state, value) {
      state.remindersNextCustomId = value;
      localStorage.setItem("remindersNextCustomId", JSON.stringify(value));
    },
    remindersUpdating(state, value) {
      state.remindersUpdating = value;
    },
    reviewData(state, value) {
      state.reviewData = value;
      localStorage.setItem('reviewData', JSON.stringify(value));
    },
    securityWall(state, value) {
      state.securityWall = value;
      localStorage.setItem("securityWall", JSON.stringify(value));
    },
    showSimpleGameTutorial(state, value) {
      state.showSimpleGameTutorial = value;
      localStorage.setItem("showSimpleGameTutorial", JSON.stringify(value));
    },
    showBoardGameTutorial(state, value) {
      state.showBoardGameTutorial = value;
      localStorage.setItem("showBoardGameTutorial", JSON.stringify(value));
    },
    showHalloweenGameTutorial(state, value) {
      state.showHalloweenGameTutorial = value;
      localStorage.setItem("showHalloweenGameTutorial", JSON.stringify(value));
    },
    showPlayExtra(state, value) {
      state.showPlayExtra = value;
    },
    showPositions(state, value) {
      state.showPositions = value;
    },
    storiesSubstituteNames(state, value) {
      state.storiesSubstituteNames = value;
      localStorage.setItem("storiesSubstituteNames", JSON.stringify(value));
    },
    syncReminder(state, value) {
      state.syncReminder = value;
      localStorage.setItem('syncReminder', JSON.stringify(value));
    },
    timestampBeforeTemporaryPause(state, value) {
      state.timestampBeforeTemporaryPause = value;
    },
    upgradePromptPoints(state, value) {
      state.upgradePromptPoints = value;
      localStorage.setItem('upgradePromptPoints', value);
    },
    userData(state, value) {
      state.userData = value;
      localStorage.setItem("userData", JSON.stringify(value));

      if (window.cordova) {
        if (value !== null) {
          window.CdvPurchase.store.applicationUsername = value.appstore_uuid;
          window.cordova.plugins.SingularCordovaSdk.setCustomUserId(value.id);
        } else {
          window.CdvPurchase.store.applicationUsername = '';
          window.cordova.plugins.SingularCordovaSdk.unsetCustomUserId();
        }
      }
    },
    whatsNewData(state, value) {
      state.whatsNewData = value;
      localStorage.setItem('whatsNewData', JSON.stringify(value));
    },
    latestBadgeId(state, value) {
      state.latestBadgeId = value;
      localStorage.setItem('latestBadgeId', JSON.stringify(value));
    },
  },
  actions: {
    initializeCdvPurchaseStore(context) {
      if (context.state.initializeCdvPurchaseStoreCalled) {
        return;
      }

      context.commit('initializeCdvPurchaseStoreCalled');

      window.CdvPurchase.store.initialize();
    },
    async updateReminderSettings(context, newReminderSettings) {
      async function scheduleReminder(reminder) {
        let time = reminder.time.split(':');
        let hour = parseInt(time[0], 10);
        let minute = parseInt(time[1], 10);

        // First check for permissions
        const permissions = await LocalNotifications.checkPermissions();
        if (permissions.display !== 'granted') {
          // Ask for permissions
          await LocalNotifications.requestPermission();
        }

        if (reminder.recurrence == 'daily') {
          await LocalNotifications.schedule({ 
            notifications: [
              {
                id: reminder.ids[0],
                title: reminder.reminder_text,
                schedule: {
                  on: { hour, minute },
                  repeats: true,
                },
              }
            ]
          });

        }
        else if (reminder.recurrence == 'weekly') {
          let dayMap = {
            Mon: '1',
            Tue: '2',
            Wed: '3',
            Thu: '4',
            Fri: '5',
            Sat: '6',
            Sun: '7',
          };

          let baseId = reminder.ids[0].toString().slice(0, -1);

          for (let day of reminder.weekly_days) {
            let id = parseInt(baseId + dayMap[day], 10);

            await LocalNotifications.schedule({
              notifications: [
                {
                  id,
                  title: reminder.reminder_text,
                  schedule: {
                    on: { weekday: parseInt(dayMap[day], 10), hour, minute },
                    repeats: true,
                  },
                }
              ]
            })
          }
        }
      }

      async function scheduleReminderPWA(reminders) {
        // Import Firebase functions for v8
        const firebase = await import('firebase/app');
        await import('firebase/functions');
        
        const functions = firebase.default.functions();
        const scheduleReminder = functions.httpsCallable('scheduleReminder');
        
        try {
          const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          console.log('User timezone:', userTimezone);
          await scheduleReminder({
            userId: context.state.userData.id,
            reminders: reminders,
            userTimezone: userTimezone,
          });
          console.log('Reminders scheduled via Firebase Functions');
        } catch (error) {
          console.error('Error scheduling reminders:', error);
          throw error;
        }
      }

      context.commit('remindersUpdating', true);

      let oldReminderSettings =
        JSON.parse(JSON.stringify(context.state.reminderSettings));
      context.commit('reminderSettings', newReminderSettings);

      if (context.state.appPlatform === 'web') {
        // PWA version using Firebase Functions
        try {
          await scheduleReminderPWA(newReminderSettings);
        } catch (error) {
          console.error('Failed to schedule PWA reminders:', error);
          // Optionally revert the state change
          context.commit('reminderSettings', oldReminderSettings);
        }
      } else {
        // Cordova version (existing code)
        // Handle deleted reminders
        for (let [reminderName, oldReminder] of Object.entries(oldReminderSettings)) {
          if (newReminderSettings[reminderName] === undefined) {
            const descriptors = oldReminder.ids.map(id => ({ id }));
            await LocalNotifications.cancel({ notifications: descriptors })
          }
        }

        // Handle updated reminders
        for (let [reminderName, newReminder] of Object.entries(newReminderSettings)) {
          let oldReminder = oldReminderSettings[reminderName];

          if (
            oldReminder !== undefined &&
            (
              oldReminder.reminder_text !== newReminder.reminder_text ||
              oldReminder.recurrence !== newReminder.recurrence ||
              JSON.stringify(oldReminder.weekly_days) !== JSON.stringify(newReminder.weekly_days) ||
              oldReminder.time !== newReminder.time ||
              oldReminder.enabled !== newReminder.enabled
            )
          ) {
            const descriptors = oldReminder.ids.map(id => ({ id }));
            await LocalNotifications.cancel({ notifications: descriptors })

            if (newReminder.enabled) {
              scheduleReminder(newReminder);
            }
          }
        }

        // Handle new reminders
        for (let [reminderName, newReminder] of Object.entries(newReminderSettings)) {
          if (oldReminderSettings[reminderName] === undefined) {
            scheduleReminder(newReminder);
          }
        }
      }

      context.commit('remindersUpdating', false);
    }
  },
  modules: {
  }
})